(function () {
  if (window.intCdInit) return;
  window.intCdInit = true;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function afficher(etat) {
    var d = document.querySelector('cart-drawer');
    if (d && etat && etat.sections) d.renderContents(etat);
  }
  function message(texte) {
    var m = document.querySelector('[data-int-promo-msg]');
    if (m) { m.textContent = texte; m.hidden = false; }
  }
  function envoyer(url, corps) {
    corps.sections = SECTIONS;
    corps.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
      .then(function (r) { return r.json(); });
  }
  function aDuo(etat) {
    return (etat.items || []).some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (a) {
        return a.amount > 0 && /Duo/.test((a.discount_application || {}).title || '');
      });
    });
  }
  function appliquerCode(code) {
    var duoAvant = !!document.querySelector('.int-cd-duo--ok');
    return envoyer('/cart/update.js', { discount: code }).then(function (etat) {
      var refuse = code && (etat.discount_codes || []).some(function (c) { return !c.applicable; });
      if (!refuse) {
        afficher(etat);
        if (code && duoAvant && !aDuo(etat)) message("Votre code remplace l'Offre Duo (les deux offres ne sont pas cumulables).");
        return;
      }
      return envoyer('/cart/update.js', { discount: '' }).then(function (e2) {
        afficher(e2);
        message("Le code " + code.toUpperCase() + " ne s'applique pas à ce panier : il ne concerne pas ces articles ou n'est pas cumulable avec l'Offre Duo.");
      });
    });
  }
  function refusAssu() { try { return sessionStorage.getItem('intAssuRefus') === '1'; } catch (e) { return false; } }
  function autoAssu() {
    var a = document.querySelector('[data-int-assu-auto]');
    if (!a || a.checked || a.disabled || refusAssu() || window.intAssuEnCours) return;
    window.intAssuEnCours = true;
    a.checked = true; a.disabled = true;
    envoyer('/cart/add.js', { items: [{ id: Number(a.getAttribute('data-int-assu')), quantity: 1 }] })
      .then(afficher).finally(function () { window.intAssuEnCours = false; });
  }
  function nettoyer() {
    autoAssu();
    var o = document.querySelector('[data-int-assu-orphan]');
    if (o && !o.dataset.fait) {
      o.dataset.fait = '1';
      envoyer('/cart/change.js', { id: String(o.getAttribute('data-int-assu-orphan')), quantity: 0 }).then(afficher);
    }
  }
  var tiroir = document.querySelector('cart-drawer');
  if (tiroir) new MutationObserver(nettoyer).observe(tiroir, { childList: true, subtree: true });
  nettoyer();
  document.addEventListener('change', function (e) {
    var a = e.target.closest && e.target.closest('[data-int-assu]');
    if (!a) return;
    var id = Number(a.getAttribute('data-int-assu'));
    if (!a.checked) { try { sessionStorage.setItem('intAssuRefus', '1'); } catch (err) {} }
    a.disabled = true;
    (a.checked
      ? envoyer('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : envoyer('/cart/change.js', { id: String(id), quantity: 0 })
    ).then(afficher).catch(function () { a.disabled = false; a.checked = !a.checked; });
  });
  document.addEventListener('click', function (e) {
    var ajout = e.target.closest('[data-int-up-add]');
    if (ajout) {
      e.preventDefault();
      ajout.disabled = true;
      ajout.textContent = 'Ajout…';
      envoyer('/cart/add.js', { items: [{ id: Number(ajout.getAttribute('data-int-up-add')), quantity: 1 }] })
        .then(function (etat) {
          if (etat.status) { ajout.textContent = 'Indisponible'; return; }
          afficher(etat);
        })
        .catch(function () { ajout.disabled = false; ajout.textContent = '+ Ajouter'; });
      return;
    }
    if (e.target.closest('[data-int-promo-appliquer]')) {
      var champ = document.querySelector('[data-int-promo-saisie]');
      var code = champ ? champ.value.trim() : '';
      if (code) appliquerCode(code);
      return;
    }
    if (e.target.closest('[data-int-promo-retirer]')) {
      appliquerCode('');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-int-promo-saisie]')) {
      e.preventDefault();
      var code = e.target.value.trim();
      if (code) appliquerCode(code);
    }
  });
})();
